import { ReactComponent as KalamaLockup } from 'src/assets/images/kalama-lockup-horizontal.svg'
import { KALAMA_HELP_ARTICLE_URL } from 'src/modules/brand/utils/kalama-notice'
import { FormattedText, Modal } from 'src/modules/core/components'
import type { KalamaRenamedModalProps } from './kalama-renamed-modal.interface'
import classes from './kalama-renamed-modal.module.scss'

export function KalamaRenamedModal({ open, onClose }: KalamaRenamedModalProps) {
  if (!open) {
    return null
  }

  return (
    <Modal variant="primary" closeOnBackdropClick={false} onClose={onClose}>
      <div className={classes.root} data-testid="kalama-renamed-modal">
        <KalamaLockup className={classes.lockup} title="Kalama" />
        <p className={classes.message}>
          <FormattedText id="brand.kalamaRenamed.message" />
        </p>
        <a className={classes.link} href={KALAMA_HELP_ARTICLE_URL} target="_blank" rel="noopener noreferrer">
          <FormattedText id="brand.kalamaRenamed.link" />
        </a>
      </div>
    </Modal>
  )
}
